import styled from "styled-components";

const StyledButton = styled.button`
  border: 1px solid;
  border-radius: 8px;
  font-size: 15px;
  font-weight: 500;
  display: inline-flex;
  gap: 8px;
  min-height: 42px;
  align-items: center;
  padding: 6px 16px;
  cursor: pointer;
  transition: all 0.2s ease;

  ${(props) =>
    props.variant === "primary" &&
    `
    background: #DDEAF8;
    color: #004181;
    border: 1.5px solid #004181;
    
    &:hover { 
    background: #aacbec;
    color: #004181;
    border: 1.5px solid #004181;
    }
  `}

  ${(props) =>
    props.variant === "secondary" &&
    `
    background: #FFEFEF;
    color: #FF0000;
    border: 1.5px solid #FF0000;
    
    &:hover {
      background: #fee0e0;
      color: #FF0000;
      border: 1.5px solid #FF0000;
    }
  `}
    svg {
    flex-shrink: 0;
    margin-right: ${(props) => (props.hasIcon ? "8px" : "0")};
  }
  & > span {
    display: inline-block;
  }
`;

const AdminActionsButton = ({ children, variant = "primary", ...props }) => {
  return (
    <StyledButton variant={variant} {...props}>
      {children}
    </StyledButton>
  );
};

export default AdminActionsButton;
